import React from 'react';
import axios from 'axios'; // Importa axios
import Swal from 'sweetalert2';
import GestionDirecta from './VentaDirecta/GestionDirecta';
import ModalPresupuesto from "./Presupuestos/ModalPresupuesto";
import { 
  Box,
  Typography,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button
} from '@mui/material';
import NuevaCita from './NuevaCita';
import { Dialog } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import CitaCard from './CitaCard';
import './Agenda.css';
import  GestionCita from './GestionCita';
import GestiondeCita from './Gestion/GestiondeCita';
import CrearNota from './CrearNota'; // Asegúrate de que la ruta sea correcta
const Agenda = ({ selectedDate, onDateChange, citas,onCitaDeleted,onCitaCreada, setNotasActualizadas,  onActualizarCita, totalCitas,setMostrarFichaje,
  onRecargarCitas,   salonSeleccionado  }) => {
     console.log("Salón seleccionado:", salonSeleccionado); // <-- Aquí el log
    const [openGestionDirecta, setOpenGestionDirecta] = React.useState(false);

    const [empleados, setEmpleados] = React.useState([]);
    const [isEmpleadoAvailable, setIsEmpleadoAvailable] = React.useState(true);

  const [openNotaModal, setOpenNotaModal] = React.useState(false);
const [openPresupuesto, setOpenPresupuesto] = React.useState(false);
    const [gestionCitaData, setGestionCitaData] = React.useState({
        open: false,
        idCita: null  
      });

      
const tableContainerRef = React.useRef(null);


React.useEffect(() => {
  if (!tableContainerRef.current) return;

  // Hora actual en formato HH:MM (ej: "10:00")
  const now = new Date();
  const currentHour = `${now.getHours().toString().padStart(2, '0')}:00`;

  // Busca si existe fila con esa hora
  const row = document.getElementById(`row-${currentHour}`);
  if (row && row.scrollIntoView) {
    row.scrollIntoView({
      behavior: 'smooth',
      block: 'center' // 👈 la centra en el scroll
    });
  }
}, [selectedDate]); // 👈 se ejecuta cada vez que cambies el día
      
      const handleDeleteCita = async (idCita) => {
        try {
            // Llamar a la función del padre para manejar la eliminación
            await onCitaDeleted(idCita);
            
            // No necesitas hacer la llamada API aquí porque ya se maneja en el padre
        } catch (error) {
            console.error('Error al eliminar la cita:', error);
        }
    };
    


      
  // Formatear fecha
  const formatDate = (date) => {
    const options = { weekday: 'long', day: 'numeric', month: 'long' };
    return date.toLocaleDateString('es-ES', options);
  };


  const handleDobleClickCita = async (idCita) => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/empleadodisponible`);
  
      if (response.data === true) {
        setIsEmpleadoAvailable(true);
  

  
        setGestionCitaData({
          open: true,
          idCita: idCita
        });
  
      } else {
        setIsEmpleadoAvailable(false);
  
        await Swal.fire({
          icon: 'warning',
          title: 'Atención',
          text: 'Debe Fichar primero para gestionar una cita.',
          confirmButtonText: 'Aceptar'
        });
      }
    } catch (error) {
      console.error('Error al obtener empleados:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Hubo un problema al verificar empleados. Intente nuevamente.',
        confirmButtonText: 'Cerrar'
      });
    }
  };
  



  const [openNuevaCita, setOpenNuevaCita] = React.useState(false);
  const [citaData, setCitaData] = React.useState({
    fecha: '',
    hora: '',
    id_puesto: null
  });
  
  const handleAddCita = (time, puesto) => {
    // Corrige el problema de zona horaria
    const localDate = new Date(selectedDate);
    const offset = localDate.getTimezoneOffset();
    const correctedDate = new Date(localDate.getTime() - (offset * 60 * 1000));
    const formattedDate = correctedDate.toISOString().split('T')[0];
    
    const newCitaData = {
      fecha: formattedDate,
      hora: time,
      id_puesto: puesto,
      id_salon: salonSeleccionado
    };  
    

    
    setCitaData(newCitaData);
    setOpenNuevaCita(true);
  };

  const adjustedDate = new Date(selectedDate);
adjustedDate.setMinutes(adjustedDate.getMinutes() - adjustedDate.getTimezoneOffset()); // Ajuste para zona horaria
const formattedDate = adjustedDate.toISOString().split('T')[0]; // Obtiene YYYY-MM-DD


  // Navegar entre días
  const navigateDay = (offset) => {
    const newDate = new Date(selectedDate);
    newDate.setDate(newDate.getDate() + offset);
    onDateChange(newDate);
  };

  // Generar horas de 09:00 a 19:00 con saltos de 15min
  const generateTimeSlots = () => {
    const slots = [];
    for (let hour = 9; hour <= 19; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const time = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
        slots.push(time);
      }
    }
    return slots;
  };

  // Ir al día actual
  const goToToday = () => {
    onDateChange(new Date());
  };

  // Organizar citas por hora y puesto
// Función para organizar citas por hora y puesto
const organizeAppointments = () => {
    const organized = {};
    let hasLogged = false;

    if (!Array.isArray(citas)) return organized;

    citas.forEach(cita => {
        if (cita && cita.fecha_hora) {
            try {
                const [date, time] = cita.fecha_hora.split(' ');
                const startTime = time.substring(0, 5);
                const duration = cita.duracion_total || 15;

                // Calcular número de celdas de 15 minutos que ocupa (redondeando hacia arriba)
                const slotsNeeded = Math.ceil(duration / 15);

                // Generar todas las franjas horarias que ocupará esta cita
                const timeSlots = [];
                for (let i = 0; i < slotsNeeded; i++) {
                    const minutesToAdd = i * 15;
                    const newTime = new Date(`${date}T${startTime}:00`);
                    newTime.setMinutes(newTime.getMinutes() + minutesToAdd);
                    const formattedTime = newTime.toTimeString().substring(0, 5);
                    timeSlots.push(formattedTime);
                }

                // Separar celda principal y secundarias
                const celdaPrincipal = timeSlots[0];
                const celdasSecundarias = timeSlots.slice(1);

                // Registrar la cita en todas sus franjas horarias
                timeSlots.forEach((timeSlot, index) => {
                    if (!organized[timeSlot]) {
                        organized[timeSlot] = [];
                    }

                    organized[timeSlot].push({
                        ...cita,
                        celda_principal: celdaPrincipal,
                        celdas_secundarias: celdasSecundarias,
                        isMainCell: index === 0, // true solo para la primera celda
                        slotsNeeded,
                        startTime // Guardamos la hora de inicio original
                    });
                });

      

            } catch (error) {
                console.error('Error procesando cita:', cita, error);
            }
        }
    });


    return organized;
};



const getCitaParaCelda = (time, puesto) => {
    const citasEnHora = appointmentsByTime[time] || [];
    // Busca todas las citas para este puesto
    const citasPuesto = citasEnHora.filter(c => c.id_puesto === puesto);
  
    // Verificar si ya existe una cita principal
    const citaPrincipal = citasPuesto.find(c => c.isMainCell); // Cita principal tiene prioridad
  
    if (citaPrincipal) {
      return {
        ...citaPrincipal,  // Retorna la cita principal si la encuentra
        isMainCell: true,
      };
    }
  
    // Si no hay cita principal, pero hay citas secundarias, mostrar como "ocupado"
    const citaSecundaria = citasPuesto.find(c => !c.isMainCell);
    if (citaSecundaria) {
      return {
        isSecondary: true,  // Indicamos que esta celda es secundaria
      };
    }
  
    return null;  // No hay citas en esta celda
  };
  
  

  
  
  const appointmentsByTime = organizeAppointments();
  const timeSlots = generateTimeSlots();
 
  return (
    <Box className="agenda-container">
      <Paper elevation={3} className="agenda-paper">
<Box 
  className={`agenda-header ${salonSeleccionado === 2 ? 'salon-dos' : ''}`}
>
  <Button 
    variant="contained" 
    onClick={() => setOpenNotaModal(true)} // Abre el modal
    className="today-button"
  >
    + Añadir Nota
  </Button>

  {/* Botón Fichar */}
  <Button 
    variant="contained" 
 
    onClick={() => setMostrarFichaje(true)}  // Al hacer 
    className="fichar-button"

  >
    Fichar
  </Button>

  <IconButton onClick={() => navigateDay(-1)} className="nav-button">
    <ChevronLeft />
  </IconButton>
  
  {/* Contenedor para fecha y contador */}
  <Box sx={{ display: 'flex', alignItems: 'center' }}>
  <span className="citas-counter-chip">
    {totalCitas} citas
  </span>
  <Typography variant="h5" className="date-title" sx={{ marginLeft: 2 }}>
    {formatDate(selectedDate)}
  </Typography>


</Box>


  <IconButton onClick={() => navigateDay(1)} className="nav-button">
    <ChevronRight />
  </IconButton>


<Button 
  variant="contained" 
  className="today-button"
  color="success"
  onClick={() => setOpenGestionDirecta(true)}
>
  Venta Directa
</Button>



<Button
  variant="contained"
  color="warning"
  onClick={() => setOpenPresupuesto(true)}
>
  Presupuestos
</Button>

  <Button 
    variant="contained" 
    onClick={goToToday}
    className="today-button"
  >
    Hoy
  </Button>
</Box>


        <TableContainer className="agenda-table-container" ref={tableContainerRef}>
          <Table>
            <TableHead>
              <TableRow className="column-header">
                <TableCell className="time-header">Hora</TableCell>
                <TableCell className="position-header">Puesto 1</TableCell>
                <TableCell className="position-header">Puesto 2</TableCell>
                <TableCell className="position-header">Puesto 3</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
  {timeSlots.map((time, index) => {
    // Intentamos asignar citas a diferentes puestos dinámicamente
    const puesto1 = getCitaParaCelda(time, 1);
    const puesto2 = getCitaParaCelda(time, 2);
    const puesto3 = getCitaParaCelda(time, 3);

    return (
<TableRow 
  key={index} 
   id={`row-${time}`}  // 👈 identificador único por hora
  className={`time-slot-row ${puesto1 || puesto2 || puesto3 ? 'has-appointment' : ''}`}
>
  <TableCell className="time-cell">{time}</TableCell>
  
  {/* Puesto 1 */}
  <TableCell className={`position-cell ${puesto1 ? 'has-appointment' : ''}`}>
    {puesto1 ? (
      puesto1.isSecondary ? (
        <Box className="ocupado-cell">
          <Typography variant="body2"></Typography>
        </Box>
      ) : (
        <CitaCard 
          cita={puesto1} 
          onDoubleClick={() => handleDobleClickCita(puesto1.id_cita)}
          onDelete={handleDeleteCita}
        />
      )
    ) : (
      <Button 
        variant="outlined"   
        onClick={() => handleAddCita(time, 1)}
        className="add-cita-button"
      >
        +
      </Button>
    )}
  </TableCell>

  {/* Puesto 2 */}
  <TableCell className={`position-cell ${puesto2 ? 'has-appointment' : ''}`}>
    {puesto2 ? (
      puesto2.isSecondary ? (
        <Box className="ocupado-cell">
          <Typography variant="body2"></Typography>
        </Box>
      ) : (
        <CitaCard 
          cita={puesto2} 
          onDoubleClick={() => handleDobleClickCita(puesto2.id_cita)}
          onDelete={handleDeleteCita}
        />
      )
    ) : (
      <Button 
        variant="outlined"   
        onClick={() => handleAddCita(time, 2)}
        className="add-cita-button"
      >
        +
      </Button>
    )}
  </TableCell>

  {/* Puesto 3 */}
  <TableCell className={`position-cell ${puesto3 ? 'has-appointment' : ''}`}>
    {puesto3 ? (
      puesto3.isSecondary ? (
        <Box className="ocupado-cell">
          <Typography variant="body2"></Typography>
        </Box>
      ) : (
        <CitaCard 
          cita={puesto3} 
          onDoubleClick={() => handleDobleClickCita(puesto3.id_cita)}
          onDelete={handleDeleteCita}
        />
      )
    ) : (
      <Button 
        variant="outlined"   
        onClick={() => handleAddCita(time, 3)}
        className="add-cita-button"
      >
        +
      </Button>
    )}
  </TableCell>
</TableRow>
    );
  })}
</TableBody>



          </Table>
        </TableContainer>
      </Paper>
      <Dialog
  open={openNuevaCita}
  onClose={() => setOpenNuevaCita(false)}
  maxWidth="md"
  fullWidth
>



<NuevaCita
  open={openNuevaCita}
  onClose={() => setOpenNuevaCita(false)}
  citaData={citaData}
  onCitaCreada={onCitaCreada} // Pasa la prop a NuevaCita
/>


</Dialog>


{/* Modal para Venta Directa (debe estar fuera del anterior) */}
<Dialog
  open={openGestionDirecta}
  onClose={() => setOpenGestionDirecta(false)}
  maxWidth="xl"
  fullWidth
  PaperProps={{
    style: { height: '90vh', margin: 0 }
  }}
>
  <GestionDirecta />
</Dialog>



{/* Modal para Nota */}
<Dialog
  open={openNotaModal}
  onClose={() => setOpenNotaModal(false)}
  maxWidth="auto"
  PaperProps={{
    style: {
      backgroundColor: 'transparent', // Rojo sólido
    }
  }}
>
<CrearNota 
  selectedDate={formattedDate} 
  onClose={() => setOpenNotaModal(false)} 
  onNotaCreated={() => setNotasActualizadas(true)}
  
/>

</Dialog>




<ModalPresupuesto
  open={openPresupuesto}
  onClose={() => setOpenPresupuesto(false)}
/>


<GestiondeCita
  open={gestionCitaData.open}
  onClose={() => {
    setGestionCitaData({...gestionCitaData, open: false});
    onRecargarCitas(); // 👈 Asegura la recarga al cerrar
  }}
  idCita={gestionCitaData.idCita}
  onRecargarCitas={onRecargarCitas}
/>
    </Box>
  );
};

export default Agenda;